import { differenceInCalendarDays, isBefore, isSameDay } from 'date-fns'

import { SliceState, TravelPeriodSlice } from './types'

export const createTravelPeriodSlice: SliceState<TravelPeriodSlice> = (set) => ({
	travelPeriod: {
		federalState: undefined,
		showCrossSelling: false,
		nights: 0,
	},
	setTravelDate: (date: Date) =>
		set(
			(state) => {
				const { startDate, endDate } = state.travelPeriod
				if (!startDate || endDate) {
					return {
						...state,
						travelPeriod: {
							...state.travelPeriod,
							endDate: undefined,
							startDate: date,
							nights: 0,
						},
					}
				}

				if (isBefore(date, startDate)) {
					const nights = differenceInCalendarDays(startDate, date)
					return {
						...state,
						travelPeriod: {
							...state.travelPeriod,
							nights,
							startDate: date,
							endDate: startDate,
						},
					}
				}

				if (isSameDay(date, startDate)) return state

				const nights = differenceInCalendarDays(date, state.travelPeriod.startDate!)
				return { ...state, travelPeriod: { ...state.travelPeriod, nights, endDate: date } }
			},
			false,
			'setTravelDate'
		),
	setFederalState: (federalState?: string) =>
		set(
			(state) => ({
				...state,
				travelPeriod: {
					...state.travelPeriod,
					federalState: federalState === 'reset' ? undefined : federalState,
				},
			}),
			false,
			'setFederalState'
		),
	setShowCrossSelling: (value: boolean) =>
		set(
			(state) => ({
				...state,
				travelPeriod: { ...state.travelPeriod, showCrossSelling: value },
			}),
			false,
			'setShowCrossSelling'
		),
	setTravelPeriod: (startDate: Date, endDate: Date) =>
		set(
			(state) => ({
				...state,
				travelPeriod: {
					...state.travelPeriod,
					startDate,
					endDate,
					nights: differenceInCalendarDays(endDate, startDate),
				},
			}),
			false,
			'setTravelPeriod'
		),
	resetTravelPeriod: () =>
		set(
			(state) => ({
				...state,
				travelPeriod: {
					...state.travelPeriod,
					startDate: undefined,
					endDate: undefined,
					nights: 0,
				},
			}),
			false,
			'resetTravelPeriod'
		),
})
